document.addEventListener('DOMContentLoaded', () => {
  const html = document.documentElement;
  const hideShopifyPreviewBar = () => {
    if (!html.classList.contains('shopify-design-mode')) {
      return;
    }

    const previewBarSelectors = [
      '#preview-bar-iframe',
      '#PreviewBar',
      '.shopify-preview-bar',
      'iframe[id*="preview-bar"]',
      'iframe[src*="preview_bar"]',
      'iframe[src*="preview-bar"]'
    ];

    previewBarSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((node) => {
        node.style.setProperty('display', 'none', 'important');
        node.style.setProperty('visibility', 'hidden', 'important');
        node.style.setProperty('opacity', '0', 'important');
        node.style.setProperty('pointer-events', 'none', 'important');
      });
    });

    document.body.style.setProperty('padding-bottom', '0px', 'important');
    html.style.setProperty('--preview-bar-height', '0px');
    html.style.setProperty('--shopify-preview-bar-height', '0px');
  };

  hideShopifyPreviewBar();

  if (html.classList.contains('shopify-design-mode')) {
    const previewBarObserver = new MutationObserver(() => {
      hideShopifyPreviewBar();
    });

    previewBarObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  }

  const body = document.body;
  const mobileMenu = document.getElementById('MobileMenu');
  const overlay = document.getElementById('MobileMenuOverlay');
  const openButton = document.querySelector('[data-mobile-menu-toggle]');
  const closeButtons = document.querySelectorAll('[data-mobile-menu-close]');
  const submenuButtons = document.querySelectorAll('[data-mobile-submenu-toggle]');

  if (mobileMenu && overlay && openButton) {
    const setMenuState = (isOpen) => {
      mobileMenu.classList.toggle('is-open', isOpen);
      overlay.hidden = !isOpen;
      mobileMenu.setAttribute('aria-hidden', String(!isOpen));
      openButton.setAttribute('aria-expanded', String(isOpen));
      body.classList.toggle('mobile-menu-open', isOpen);
    };

    setMenuState(false);

    openButton.addEventListener('click', () => setMenuState(true));

    closeButtons.forEach((button) => {
      button.addEventListener('click', () => setMenuState(false));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        setMenuState(false);
      }
    });

    submenuButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const submenuId = button.getAttribute('aria-controls');
        const submenu = submenuId ? document.getElementById(submenuId) : null;
        const isOpen = button.getAttribute('aria-expanded') === 'true';

        if (!submenu) {
          return;
        }

        button.setAttribute('aria-expanded', String(!isOpen));
        submenu.hidden = isOpen;
      });
    });
  }

  const sections = Array.from(document.querySelectorAll('.site-main > .shopify-section')).filter((section, index) => {
    return index > 0;
  });
  const revealSelector = [
    '.card',
    'article',
    '.home-featured-products__card',
    '.home-blog-feed__item',
    '.home-review-highlights__card',
    '.home-collection-cards__card',
    '.home-dynamic-cards__card',
    '.product-recommendations-custom__card',
    '.product-reviews__card',
    '.collection-card'
  ].join(', ');

  const prepareRevealItems = (section) => {
    const candidates = Array.from(section.querySelectorAll(revealSelector)).filter((node) => {
      return !node.closest('[data-lazy-item]') && !node.closest('.shopify-section')?.isSameNode(node);
    });

    if (candidates.length < 2) {
      return;
    }

    candidates.forEach((node, index) => {
      node.setAttribute('data-lazy-item', '');
      node.style.setProperty('--lazy-delay', `${Math.min(index * 0.08, 0.48)}s`);
    });
  };

  if (sections.length) {
    sections.forEach((section) => {
      prepareRevealItems(section);
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.setAttribute('data-lazy-state', 'visible');
            observer.unobserve(entry.target);
          });
        },
        {
          rootMargin: '120px 0px -5% 0px',
          threshold: 0.06
        }
      );

      sections.forEach((section) => {
        section.setAttribute('data-lazy-state', 'pending');
        observer.observe(section);
      });
    } else {
      sections.forEach((section) => {
        section.setAttribute('data-lazy-state', 'visible');
      });
    }
  }
});
